import { BOTH, BOTTOM, TOP } from "../constants/posterAttributesPositions"

const getPosterAttributeSettings = (posterAttribute) => {
    const showPosterAttribute = posterAttribute && posterAttribute.name && posterAttribute.name !== '' && posterAttribute.position !== '' ? true : false
    const posterAttributeTop = posterAttribute && posterAttribute.position && (posterAttribute.position === TOP || posterAttribute.position === BOTH) ? true : false
    const posterAttributeBottom = posterAttribute && posterAttribute.position && (posterAttribute.position === BOTTOM || posterAttribute.position === BOTH) ? true : false
    const hasPosterAttributeClass = showPosterAttribute && posterAttributeTop ? ' has-optional-attribute' : ''
    const hasPosterAttributeBottomClass = showPosterAttribute && posterAttributeBottom ? ' has-bottom-attribute' : ''

    return {
        posterAttributeTop: posterAttributeTop,
        posterAttributeBottom: posterAttributeBottom,
        hasPosterAttributeClass: hasPosterAttributeClass,
        hasPosterAttributeBottomClass: hasPosterAttributeBottomClass
    }
}

export default getPosterAttributeSettings